import React from 'react';
import {Block, Title, Icon, Loader} from '../../../components/components'
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useHistory, useRouteMatch, useParams } from 'react-router-dom';
import Pagination from "../../../components/tables/Pagination";
import useCustomTable from "../../../components/tables/useCustomTable";
import {TableSearchRow} from "../../../components/tables/TableSearch";
import Table from "../../../components/tables/Table";
import { useGetExtractsQuery } from '../../../api/extractApiSlice';

export default function ExtractsList() {
	const { t } = useTranslation();
  const { dataVendorKey } = useParams();
  const history = useHistory();
  const {
    data: extracts = [],
    isSuccess,
    isError,
    refetch
  } = useGetExtractsQuery()
  const { path } = useRouteMatch();
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }

  const columns = [{
    	Header: 'Name',
    	accessor: 'name',
  	},{
      Header: 'Key',
      accessor: 'key'
    },{
    	Header: 'Extract',
    	accessor: 'extract',
    	disableSortBy: true
  	},{
    	Header: 'Created at',
    	accessor: 'created_at',
  	}
  ]

  const newExtract = () => history.push(`/data_vendors/${dataVendorKey}/new`)

  const showExtract = (rowData) => history.push(`/data_vendors/${dataVendorKey}/${rowData.key}`)

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

	return (
    <>
			<Title main={t("menu.extracts")} >
        <Button variant='primary' onClick={newExtract}>
          <Icon icon='plus' text={t("extract.new")} />
        </Button>
      </Title>
      <TableSearchRow {...tableSearchProps}/>
      <Block className="mb-0">
        <Loader {...loaderProps} >
          <Table data={extracts} columns={columns} onRowClick={showExtract} {...tableProps} />
        </Loader>
     </Block>
      <Pagination {...paginationProps}/>
		</>
	)
}
